import * as types from "../actions/types";



const initialState = {
  list: [],
  loading: false
};


export default function stages_study(state = initialState, action) {
  switch (action.type) {

    case types.SET_STAGES_STUDY_LIST:
      return {
        ...state,
        stageStudyList: action.payload,
      };

    case types.SET_EVENT_LEVELS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}